export type Platform = 'mobile' | 'desktop';

export interface SectionWWW {
	kind: SectionWWWKinds;
	link: string;
	name: string;
	nameSuffix: string;
}

export enum SectionWWWKinds {
	LIST = 'L',
	HORIZONTAL = 'H',
	BACKGROUND = 'B',
	NONE = 'N',
	GRID = 'G',
}
